module.exports = __webpack_public_path__ + "img/customer-white.11e1dca.svg";